import ShopifyBuy from "@shopify/buy-button-js";
import { resizeFn, toggleDestini } from "../js/utils";
const PUBLIC_TOKEN = "8523d3d915159e9900cac0647fd813d9";
const URL = "shop.krusteaz.com";

const client = ShopifyBuy.buildClient({
	domain: URL,
	storefrontAccessToken: PUBLIC_TOKEN,
});

const ui = ShopifyBuy.UI.init(client);

const shopifyGlobalOptions = {
	option: {},
	cart: {
		styles: {
			button: {
				"font-family": "Roboto, sans-serif",
				"font-weight": "bold",
				":hover": {
					"background-color": "#ce0045",
				},
				"background-color": "#e5004d",
				":focus": {
					"background-color": "#ce0045",
				},
				"border-radius": "40px",
			},
			title: {
				color: "#000000",
			},
			header: {
				color: "#000000",
			},
			lineItems: {
				color: "#000000",
			},
			subtotalText: {
				color: "#000000",
			},
			subtotal: {
				color: "#000000",
			},
			notice: {
				color: "#000000",
			},
			currency: {
				color: "#000000",
			},
			close: {
				color: "#000000",
				":hover": {
					color: "#000000",
				},
			},
			empty: {
				color: "#000000",
			},
			noteDescription: {
				color: "#000000",
			},
			discountText: {
				color: "#000000",
			},
			discountIcon: {
				fill: "#000000",
			},
			discountAmount: {
				color: "#000000",
			},
		},
		text: {
			total: "Subtotal",
			button: "Checkout",
		},
		popup: false,
		googleFonts: ["Roboto"],
	},
	toggle: {
		styles: {
			toggle: {
				"font-family": "Roboto, sans-serif",
				"font-weight": "bold",
				"background-color": "#e5004d",
				":hover": {
					"background-color": "#ce0045",
				},
				":focus": {
					"background-color": "#ce0045",
				},
			},
		},
		googleFonts: ["Roboto"],
	},
	lineItem: {
		styles: {
			variantTitle: {
				color: "#000000",
			},
			title: {
				color: "#000000",
			},
			price: {
				color: "#000000",
			},
			fullPrice: {
				color: "#000000",
			},
			discount: {
				color: "#000000",
			},
			discountIcon: {
				fill: "#000000",
			},
			quantity: {
				color: "#000000",
			},
			quantityIncrement: {
				color: "#000000",
				"border-color": "#000000",
			},
			quantityDecrement: {
				color: "#000000",
				"border-color": "#000000",
			},
			quantityInput: {
				color: "#000000",
				"border-color": "#000000",
			},
		},
	},
};
const products = [...document.querySelectorAll("[data-shopify-id]")];
if (products?.length === 0) {
	ui.createComponent("cart", {
		node: document.querySelector("#shopify-krusteaz-cart"),
		options: {
			...shopifyGlobalOptions,
		},
	});
}

[...document.querySelectorAll(".no-shopify-buynow-modal")].forEach((el) => {
	let containerId = el.getAttribute("data-destini-container");
	let associationId = el.getAttribute("data-destini-association");
	let APO = el.getAttribute("data-destini-apo");
	console.log("destini stuff", containerId, associationId, APO);
	el.addEventListener("click", function () {
		console.log("click");
		destini.init(containerId);
		destini.loadWidget(associationId, APO);
		// toggleModal();
	});
});

products.forEach((p) => {
	const isSingle = p.getAttribute("data-type") === "single";
	const id = p.getAttribute("data-shopify-id");
	const destiniApo = p.getAttribute("data-destini-apo");

	if (!id) return;

	let hasEvent = false;
	const events = {};
	const text = isSingle ? { outOfStock: "Find in Store" } : {};
	if (!isSingle) {
		events["beforeRender"] = function (cmp) {
			console.log("component...", cmp);
			const modal = document.querySelector(".no-shopify-buynow-modal");
			if (modal) {
				modal.classList.add("hidden");
			}
		};
		events["afterRender"] = function (cmp) {
			resizeFn();
			if (!hasEvent) {
				document
					.querySelectorAll(".shopify-buynow-modal")
					.forEach(function (buyNowButton) {
						console.log("adding buy now", buyNowButton);
						let containerId = buyNowButton.getAttribute(
							"data-destini-container"
						);
						let associationId = buyNowButton.getAttribute(
							"data-destini-association"
						);
						let APO = buyNowButton.getAttribute("data-destini-apo");
						console.log("destini stuff", containerId, associationId, APO);
						buyNowButton.addEventListener("click", function () {
							console.log("click");
							destini.init(containerId);
							destini.loadWidget(associationId, APO);
							toggleDestini();
						});
					});
				hasEvent = true;
			}
		};
	} else if (isSingle) {
		events["afterRender"] = function (cmp) {
			const el = cmp?.view?.node;
			const isDisabled = el?.querySelector("button")?.disabled;
			if (el && isDisabled) {
				const data = el.closest("[data-destini-container]");
				let containerId = data.getAttribute("data-destini-container");
				let associationId = data.getAttribute("data-destini-association");
				let APO = data.getAttribute("data-destini-apo");
				const btn = el.querySelector("button");
				const parent = btn.parentNode;
				parent.removeChild(btn);

				const newEl = document.createElement("button");
				newEl.innerText = "Find in Store";
				newEl.setAttribute(
					"class",
					"no-shopify-buynow-modal buynow modal-open btn-red mt-6 inline-block cursor-pointer"
				);
				parent.appendChild(newEl);

				newEl.addEventListener("click", function () {
					console.log("click");
					destini.init(containerId);
					destini.loadWidget(associationId, APO);
					toggleDestini();
				});
			}
		};
	}

	const isDark = p.closest(".dark-shopify-integration");

	ui.createComponent("product", {
		id,
		node: p,
		moneyFormat: "%24%7B%7Bamount%7D%7D",
		options: {
			product: {
				events,
				text,
				iframe: false,
				templates: {
					price: isSingle
						? `
							<div class="mb-4 text-left mb-{{data.classes.product.prices}}" data-element="product.prices">
								<span class="font-bold my-4 {{data.classes.product.price}} {{data.priceClass}}" data-element="product.price">{{data.formattedPrice}}</span>
								<span class="block">Pack of 4</span>
							</div>`
						: `
						<div class="mt-[10px] mb-[30px] mb-{{data.classes.product.prices}}" data-element="product.prices">
							<span class="font-bold text-[30px] ${
								isDark ? "text-black" : "text-white"
							} my-4 {{data.classes.product.price}} {{data.priceClass}}" data-element="product.price">{{data.formattedPrice}}</span>
						</div>
					`,
					button: `
						<div data-shopify-title="{{data.title}}" class="{{data.classes.product.buttonWrapper}} singlebtn" data-element="product.buttonWrapper">
							<button {{#data.buttonDisabled}}disabled{{/data.buttonDisabled}} class="btn-red {{data.classes.product.button}} {{data.buttonClass}}" data-element="product.button">
								{{data.buttonText}}
							</button>
						</div>
					`,
					buttonWithQuantity: `
						<div class="lg:inline-block">
							<div class="{{data.classes.product.quantity}} {{data.quantityClass}}" data-element="product.quantity">
								<label class="${
									isDark ? "text-black" : "text-white"
								} font-bold block" for="shopify-select">Quantity</label>
								<div class="relative">
									<select id="shopify-select" class="appearance-none w-full p-2 border-black {{data.classes.product.quantityInput}}" aria-label="Quantity" data-element="product.quantityInput">
										<option value="1">1 (4 boxes)</option>
										<option value="2">2 (8 boxes)</option>
										<option value="3">3 (12 boxes)</option>
										<option value="4">4 (16 boxes)</option>
										<option value="5">5 (20 boxes)</option>
									</select>
									<span class="text-primary-900 absolute top-[13px] right-4 -scale-y-100">
										<svg 
											class="w-4"
											xmlns="http://www.w3.org/2000/svg"
											fill="none" 
											viewBox="0 0 24 24" 
											stroke="currentColor">
											<path 
												stroke-linecap="round" 
												stroke-linejoin="round" 
												stroke-width="4" 
												d="M5 15l7-7 7 7" />
										</svg>
									</span>
								</div>
							</div>
							<div data-shopify-title="{{data.title}}" class="{{data.classes.product.buttonWrapper}} mt-6 grid justify-start gap-4 lg:gap-[28px] lg:grid-cols-2 lg:justify-normal" data-element="product.buttonWrapper">
								<button {{#data.buttonDisabled}}disabled{{/data.buttonDisabled}} class="btn-red {{data.classes.product.button}} {{data.buttonClass}}" data-element="product.button">
									{{data.buttonText}}
								</button>
								<a class="shopify-buynow-modal buynow modal-open btn-red-outline inline-block cursor-pointer" data-toggle="modal" data-target="#widget-modal" data-destini-container="destinidiv" data-destini-association="default" data-destini-apo="${destiniApo}">
									Find in Store
								</a>
							</div>
						</div>
					`,
				},
				contents: {
					img: false,
					title: false,
					price: true,
					button: true,
					quantity: false,
					quantityIncrement: false, // button to increase quantity
					quantityDecrement: false, // button to decrease quantity
					quantityInput: isSingle ? false : true, // input field to directly set quantity
					buttonWithQuantity: isSingle ? false : true,
				},
			},
			...shopifyGlobalOptions,
		},
	});
});
